
import { useI18n } from "src/utils/lni18n";
import { PublishCheckResponse } from "src/coursepart/domain/PublishCheckResponse";

export const AffectedPartsList: React.FC<{ parts: PublishCheckResponse[] }> = ({
    parts
}) => {

    const { languageService: t } = useI18n();
    return (

        <table className="table table-condensed table-striped">
            <thead>
                <tr>
                    <th>
                        {t.getText("name")}
                    </th>
                    <th>
                        {t.getText("comment")}
                    </th>
                </tr>
            </thead>
            <tbody>

                {parts.map(d => (
                    <tr key={d.PartId}>
                        <td>
                            {d.Name}
                        </td>
                        <td className="preserve-white">
                            {d.Locked &&
                                <div>{d.Message}</div>
                            }
                            {!d.Locked && d.Async &&
                                <div>{d.Message}</div>
                            }
                        </td>

                    </tr>)
                )}

            </tbody>
        </table>

    )
}
